"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.parseVideoItem = void 0;
var tslib_1 = require("tslib");
var object_1 = require("@wix/wix-vod-shared/dist/src/common/utils/object");
var video_deal_info_1 = require("@wix/wix-vod-constants/dist/common/video-deal-info");
var transcoding_statuses_1 = require("@wix/wix-vod-constants/dist/common/transcoding-statuses");
var video_sources_1 = require("@wix/wix-vod-constants/dist/common/video-sources");
var time_1 = require("@wix/wix-vod-shared/dist/src/common/utils/time");
var entity_id_1 = require("../normalizers/entity-id");
var mapMediaInfoToLiveStatus_1 = require("@wix/wix-vod-api-site-based/dist/src/utils/mapMediaInfoToLiveStatus");
var DEFAULT_DOWNLOAD_OPTIONS = { allowDownload: false };
var normalizeTranscodingStatus = function (status) {
    if (_.includes(transcoding_statuses_1.TRANSCODING_STATUSES, status)) {
        return status;
    }
    return transcoding_statuses_1.TRANSCODING_STATUSES.NONE;
};
var mapUsedInLists = function (usedInLists) {
    if (usedInLists === void 0) { usedInLists = []; }
    return usedInLists.map(function (ref) { return ({
        id: ref.itemId,
        title: ref.title,
    }); });
};
var parseVideoItem = function (itemData) {
    var camelCasedItemData = (0, object_1.keysToCamelCase)(itemData);
    var itemId = camelCasedItemData.itemId, externalId = camelCasedItemData.externalId, listId = camelCasedItemData.listId, mediaStatus = camelCasedItemData.mediaStatus, trailerStatus = camelCasedItemData.trailerStatus, mediaInfo = camelCasedItemData.mediaInfo, mediaExternUrl = camelCasedItemData.mediaExternUrl, _a = camelCasedItemData.downloadOptions, _b = _a === void 0 ? DEFAULT_DOWNLOAD_OPTIONS : _a, allowDownload = _b.allowDownload, _c = camelCasedItemData.videoSource, videoSource = _c === void 0 ? video_sources_1.VIDEO_SOURCES.COMPUTER : _c, itemType = camelCasedItemData.itemType;
    var id = (itemId && (0, entity_id_1.normalizeId)(itemId)) || externalId;
    var _d = camelCasedItemData.customCoverUrl, customCoverUrl = _d === void 0 ? null : _d, createdTsNum = camelCasedItemData.createdTs, updatedTsNum = camelCasedItemData.updatedTs, publishTsNum = camelCasedItemData.publishTs, usedInLists = camelCasedItemData.usedInLists;
    var dealInfo = camelCasedItemData.dealInfo, durationSec = camelCasedItemData.durationSec, durationStr = camelCasedItemData.durationStr, _e = camelCasedItemData.tags, tags = _e === void 0 ? [] : _e, _f = camelCasedItemData.categories, categories = _f === void 0 ? [] : _f;
    var createdTs = new Date(createdTsNum * 1000);
    var updatedTs = new Date(updatedTsNum * 1000);
    var publishTs = publishTsNum ? new Date(publishTsNum * 1000) : null;
    var fileInputDurationSec = _.get(mediaInfo, 'fileInput.duration', 0);
    if (fileInputDurationSec) {
        durationSec = Math.floor(fileInputDurationSec / 1000);
        durationStr = (0, time_1.convertSSToMMSS)(durationSec);
    }
    if (!durationStr) {
        durationStr = (0, time_1.convertSSToMMSS)(durationSec);
    }
    var transcodingStatus = normalizeTranscodingStatus(mediaExternUrl ? transcoding_statuses_1.TRANSCODING_STATUSES.READY : mediaStatus);
    var trailerTranscodingStatus = normalizeTranscodingStatus(trailerStatus);
    // external videos should be free
    if (mediaExternUrl) {
        dealInfo = video_deal_info_1.FREE_VIDEO_DEAL_INFO;
    }
    tags = _.uniq(tags);
    categories = _.uniq(categories);
    var normalizedListId = (0, entity_id_1.normalizeId)(listId);
    var clearCamelCasedItemData = _.omit(camelCasedItemData, [
        'downloadOptions',
        'mediaStatus',
        'trailerStatus',
    ]);
    var mappedCamelCasedItemData = tslib_1.__assign(tslib_1.__assign({}, clearCamelCasedItemData), { id: id, listId: normalizedListId, customCoverUrl: customCoverUrl, transcodingStatus: transcodingStatus, trailerTranscodingStatus: trailerTranscodingStatus, dealInfo: dealInfo, durationSec: durationSec, durationStr: durationStr, createdTs: createdTs, updatedTs: updatedTs, publishTs: publishTs, usedInLists: mapUsedInLists(usedInLists), allowDownload: allowDownload, videoSource: videoSource, tags: tags, categories: categories, liveVideoStatus: (0, mapMediaInfoToLiveStatus_1.mapMediaInfoToLiveVideoStatus)(mediaInfo, itemType) });
    return (0, object_1.removeUndefinedValues)(mappedCamelCasedItemData);
};
exports.parseVideoItem = parseVideoItem;
//# sourceMappingURL=video-item.js.map